import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import format from '../../helpers/format'
import analytics from '../../helpers/analytics'
import container from '../../helpers/container' 
import { Row, Col } from 'react-flexbox-grid'
import {SlideDown} from 'react-slidedown'
import { Link as ScrollLink, animateScroll as scroll } from 'react-scroll'
import {
  ContainerDivs,
  Link,
  LinkIcon,
} from '../../components'
import Styles from './Petitions.css'

@CSSModules(Styles, {allowMultiple: true})
class ManagerPetition extends Component {
  constructor(props){
    super(props)
    const petitionConfigs = {
      vanguard: {
        companyshortname: 'Vanguard',
        companyfullname: 'Vanguard Group',
        pathname: 'Vanguard',
        title: 'Vanguard Needs a No Deforestation Policy',
        url: 'https://actionnetwork.org/petitions/vanguard-needs-a-no-deforestation-policy-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/vanguard-needs-a-no-deforestation-policy-2?format=js&source=widget',
        widgetid: 'can-petition-area-vanguard-needs-a-no-deforestation-policy-2',
        imgpath: 'Vanguard',
        intro1: (
          <div>
            <p>
              Every year, the world loses an area of tropical rainforest the size of the United Kingdom.
            </p>
            <p>
              Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions. Corporate control of land for industrial plantation agriculture is also a leading cause of violent land conflicts, as these activities dispossess and displace local communities.
            </p>
            <p>
              Vanguard holds hundreds of millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests. Vanguard’s continued financing of the world’s worst deforesters exposes Vanguard and its clients to reputational and financial risk – and Vanguard has no policy in place to stop the destruction.
            </p>
          </div>
        ),
        intro2: (
          <div>
            <p>
              As one of the world’s largest investment firms, Vanguard pioneered a model of investment where the firm invests in virtually every public company in the world through passive funds – meaning it gives up any control over what those companies do. Today, Vanguard is among the world’s top investors in both fossil fuels and the companies responsible for the global deforestation crisis – and it has taken no responsibility for the destruction these companies cause to our forests, our climate, and the rights of communities.
            </p>
            <p>
              Large fund companies like Vanguard can move the entire market and play a crucial role in averting catastrophe, and instead finance the transition to a livable planet. But they won’t do it without pressure from us.
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Urge Vanguard to adopt a No Deforestation Policy!</b>
              </ScrollLink>
            </p>
          </div>
        ),
        letter: (
          <div>
            <p>
              Dear Fund Manager,
            </p>
            <p>
              Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.
            </p>
            <p>
              Environmental and human rights impacts – and climate impacts above all – are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector – and now is the time for you to get on board.
            </p>
            <p>
              Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe Vanguard needs to do the same. It is both a moral and an economic imperative. You have tremendous power – and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.
            </p>
            <p>
              Thank you.
            </p>
          </div>
        ),
      },
      blackrock: {
        companyshortname: 'BlackRock',
        companyfullname: 'BlackRock/iShares',
        pathname: 'BlackRock%2FiShares',
        title: 'Tell BlackRock to Deal With its Deforestation Problem',
        url: 'https://actionnetwork.org/petitions/tell-blackrock-to-deal-with-its-deforestation-problem-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/tell-blackrock-to-deal-with-its-deforestation-problem-2?format=js&source=widget',
        widgetid: 'can-petition-area-tell-blackrock-to-deal-with-its-deforestation-problem-2',
        imgpath: 'BlackRock/iShares',
        intro1: (
          <div>
            <p>
              Every year, the world loses an area of tropical rainforest the size of the United Kingdom.
            </p>
            <p>
              Massive deforestation to clear land for palm oil, cattle, pulp and paper, soy, rubber and timber is responsible for almost a quarter of all global greenhouse gas emissions and is also a leading cause of violent land conflicts around the world.
            </p>
            <p>
              BlackRock, the world's largest investment firm, is among the world’s top investors in the agribusiness companies responsible for destroying our tropical rainforests. To make the urgent transformations needed to end global deforestation and reign in the climate crisis, BlackRock needs to change its ways.
            </p>
          </div>
        ),
        intro2: (
          <div>
            <p>
              BlackRock owns shares in the world’s largest cattle companies, the world’s largest palm oil companies, and the world’s largest pulp and paper companies. Aside from a few public statements, BlackRock has done almost nothing to stop these companies from tearing down the world’s last great rainforests.
            </p>
            <p>
              Around the world, people of all ages, from grandmothers to youth, have been rising up to tell BlackRock to divest from destruction.
            </p>
            <p>
              As one of the largest investors in the agribusiness industry from Brazil to Borneo, there’s a lot BlackRock can do to deal with its deforestation problem. It can use shareholder power to pressure the companies it owns to end deforestation. It can vote out the managers at these companies that let the problems continue. It can make deforestation free funds a default option for all of its clients.
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Join the movement to fix BlackRock’s big deforestation problem: tell BlackRock to adopt a No Deforestation Policy!</b>
              </ScrollLink>
            </p>
            <p>
              The Wall Street titan manages a jaw-dropping $10 trillion in assets. Trillions of dollars that belong to everyday people like you and me. Trillions of dollars that could help solve the climate crisis rather than fund rainforest destruction and displacing Indigenous people.
            </p>
            <p>
              There is no way through the climate crisis that doesn’t involve making Wall Street change its ways, beginning with the biggest investors, like BlackRock. As a self-proclaimed leader in responsible investing, BlackRock should be investing our dollars in fighting the destruction of lands and communities. Together we can pressure it to change course.
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Urge BlackRock to adopt a No Deforestation Policy!</b>
              </ScrollLink>
            </p>
          </div>
        ),
        letter: (
          <div>
            <p>
              Dear Larry Fink and Michelle Edkins,
            </p>
            <p>
              To repeat a question posed by Al Gore: “Does BlackRock want to continue to finance the destruction of human civilization, or not?”
            </p>
            <p>
              Back in 2019, eight U.S. Senators urged BlackRock to disclose its due diligence in regards to the deforestation wrought by the palm oil sector. Two months later, Liberian human rights attorney Alfred Brownell blasted BlackRock during his Goldman Prize acceptance speech for financing Golden Agri-Resources, a company responsible for vast rainforest destruction and human rights abuses. At your AGM in 2020, Amazonian Indigenous leaders challenged BlackRock to get its money out of Amazon destruction. In December of that year, you heard from eighteen Members of Congress urging the same thing – stop financing companies that are burning down the Amazon. Over the last several years, people ages 8 to 80 have held protests at BlackRock offices around the world, demanding you divest from fossil fuels and defund deforestation.

            </p>
            <p>
              Don’t you think it's time BlackRock developed a policy to categorically address the deforestation risk in your portfolios?
            </p>
            <p>
              Environmental and human rights impacts – and climate impacts above all – are increasingly recognized to drive material risks to investment. Your clients and beneficiaries know it. Governments from the US and the EU to Asia know it. And youth around the world have begun to see BlackRock for what it is – one of the largest investors in the destruction of their future.
            </p>
            <p>
              You have joined the Climate Action 100+ and the Net Zero Asset Managers’ Initiative. You’ve done all the symbolic and rhetorical things – but in the face of ugly attacks from the fossil fuel-funded right wing, you’ve backtracked on your commitment to tackling climate risk as investment risk. BlackRock’s rhetoric has grown threadbare. Until BlackRock chooses to engage with the people truly impacted by the abuses of your investee companies, and until BlackRock adopts strong policies to defund deforestation – and fossil fuels – there is no reason to believe that BlackRock’s rhetoric about sustainability and social purpose has any merit whatsoever.
            </p>
            <p>
              Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and you need to do the same. It is both a moral and an economic imperative, and you know it. You have tremendous power – and the world needs you to start using that power responsibly. I urge BlackRock to adopt a strong deforestation risk policy across all your portfolios.
            </p>
            <p>
              Thank you.
            </p>
          </div>
        ),
      },
      fidelity: {
        companyshortname: 'Fidelity',
        companyfullname: 'Fidelity Investments',
        pathname: 'Fidelity%20Investments',
        title: 'Fidelity Needs a No Deforestation Policy',
        url: 'https://actionnetwork.org/petitions/fidelity-needs-a-no-deforestation-policy-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/fidelity-needs-a-no-deforestation-policy-2?format=js&source=widget',
        widgetid: 'can-petition-area-fidelity-needs-a-no-deforestation-policy-2',
        imgpath: 'Fidelity Investments',
        intro1: (
          <div>
            <p>
              Tropical rainforests are home to the world’s greatest biodiversity, to millions of indigenous peoples, and are essential to maintaining a stable climate. Today, our rainforests are facing greater threats than ever – and the investors like Fidelity that are complicit in the destruction are dragging their feet.
            </p>
          </div>
        ),
        intro2: (
          <div>
            <p>
              Deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions. Corporate control of land for industrial plantation agriculture is also a leading cause of violent land conflicts.
            </p>
            <p>
              Fidelity has huge investments in companies like Bunge, Noble Group, Golden-Agri Resources and Resolute Forest Products that grow, trade or use palm oil, beef and soy in their products but have failed to eliminate deforestation and human rights abuses from their operations. This means Fidelity has a key role to play in voting for No Deforestation policies at these companies and engaging with company management to make sure these policies are implemented.
            </p>
            <p>
              In order to do that, Fidelity needs a high-level policy to set the course.
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Tell Fidelity to adopt a No Deforestation Policy!</b>
              </ScrollLink>
            </p>
            <p>
              As one of the world’s largest fund managers, Fidelity can play a crucial role in averting catastrophic climate outcomes, and instead financing the transition to a livable planet. But Fidelity won’t do it without pressure from us.
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Urge Fidelity to adopt a No Deforestation Policy!</b>
              </ScrollLink>
            </p>
          </div>
        ),
        letter: (
          <div>
            <p>
              Dear Fund Manager,
            </p>
            <p>
              Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.
            </p>
            <p>
              Environmental and human rights impacts – and climate impacts above all – are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector – and now is the time for you to get on board.
            </p>
            <p>
              Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe Fidelity needs to do the same. It is both a moral and an economic imperative. You have tremendous power – and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.
            </p>
            <p>
              Thank you.
            </p>
          </div>
        ),
      },
      capitalgroup: {
        companyshortname: 'Capital Group',
        companyfullname: 'American Funds from Capital Group',
        title: 'Capital Group Needs a No Deforestation Policy',
        pathname: 'American%20Funds',
        url: 'https://actionnetwork.org/petitions/capital-group-needs-a-no-deforestation-policy-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/capital-group-needs-a-no-deforestation-policy-2?format=js&source=widget',
        widgetid: 'can-petition-area-capital-group-needs-a-no-deforestation-policy-2',
        imgpath: 'American Funds',
        intro1: (
          <div>
            <p>
              Things aren’t looking good for the world’s forests. With surging deforestation from Brazil to the Congo Basin, environmental policy roll backs, assaults on environmental defenders, and fires burning through rainforests on four continents, we need to drastically change course or watch as the last of our rainforests go up in smoke.
            </p>
            <p>
              Deforestation to open plantations for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions. American Funds, owned by Capital Group, has huge investments in companies like Pepsico, Yum Brands, Hormel, McDonald’s and Procter & Gamble that use palm oil, beef and paper pulp in their products but have failed to eliminate deforestation from their operations. This means Capital Group has a key role to play in voting for No Deforestation policies at these companies and engaging with company management to make sure these policies are implemented.
            </p>
          </div>
        ),
        intro2: (
          <div>
            <p>
              In order to do that, Capital Group needs to get its own house in order.
            </p>
            <p>
              If they take appropriate action, large fund companies can move the entire market and play a crucial role in averting catastrophic climate outcomes, and instead finance the transition to a livable planet. But they won’t do it without pressure from us.
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Urge Capital Group to adopt a No Deforestation Policy!</b>
              </ScrollLink>
            </p>
          </div>
        ),
        letter: (
          <div>
            <p>
              Dear Fund Manager,
            </p>
            <p>
              Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.
            </p>
            <p>
              Environmental and human rights impacts – and climate impacts above all – are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector – and now is the time for you to get on board.
            </p>
            <p>
              Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe Capital Group needs to do the same. It is both a moral and an economic imperative. You have tremendous power – and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.
            </p>
            <p>
              Thank you.
            </p>
          </div>
        ),
      },
      dimensionalfundadvisors: {
        companyshortname: 'Dimensional Fund Advisors',
        companyfullname: 'Dimensional Fund Advisors',
        title: 'Dimensional Fund Advisors Needs a No Deforestation Policy',
        pathname: 'Dimensional%20Fund%20Advisors',
        url: 'https://actionnetwork.org/petitions/dimensional-fund-advisors-needs-a-no-deforestation-policy/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/dimensional-fund-advisors-needs-a-no-deforestation-policy?format=js&source=widget',
        widgetid: 'can-petition-area-dimensional-fund-advisors-needs-a-no-deforestation-policy',
        imgpath: 'Dimensional Fund Advisors',
        intro1: (
          <div>
            <p>
              Dimensional Fund Advisors has big investments in some of the most environmentally destructive companies in the world, including tropical logging companies, beef producers, and the world’s largest palm oil growers and traders. 
            </p>
          </div>
        ),
        intro2: (
          <div>
            <p>
              Dimensional was the first large US investment firm to explicitly remove palm oil producers from its sustainability funds – so we know they are aware of the issues. But Dimensional still has huge exposure to companies like Hormel, Resolute Forest Products, Posco, and JBS, the major the Brazilian beef trader. In order to take responsibility, Dimensional should immediately implement a robust forest policy across all its investment products. 
            </p>
            <p>
              Given the high risk of illegal activity, money laundering, environmental violations, and human rights abuses associated with deforestation, Dimensional should employ heightened due diligence procedures and eliminate the most egregious and recalcitrant companies from all of its portfolios. 
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Tell Dimensional to adopt a No Deforestation Policy!</b>
              </ScrollLink>
            </p>
            <p>
              If they take appropriate action, large mutual funds companies can move the entire market and play a crucial role in averting catastrophic climate outcomes, and instead finance the transition to a livable planet. But they won’t do it without pressure from us. 
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Urge Dimensional to adopt a No Deforestation Policy!</b>
              </ScrollLink>
            </p>
          </div>
        ),
        letter: (
          <div>
            <p>
              Dear Fund Manager,
            </p>
            <p>
              Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.
            </p>
            <p>
              Environmental and human rights impacts – and climate impacts above all – are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector – and now is the time for you to get on board.
            </p>
            <p>
              Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe Dimensional Fund Advisors needs to do the same. It is both a moral and an economic imperative. You have tremendous power – and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.
            </p>
            <p>
              Thank you.
            </p>
          </div>
        ),
      },
      invesco: {
        companyshortname: 'Invesco',
        companyfullname: 'Invesco',
        title: 'Invesco Needs a No Deforestation Policy',
        pathname: 'Invesco',
        url: 'https://actionnetwork.org/petitions/invesco-needs-a-no-deforestation-policy-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/invesco-needs-a-no-deforestation-policy-2?format=js&source=widget',
        widgetid: 'can-petition-area-invesco-needs-a-no-deforestation-policy-2',
        imgpath: 'Invesco',
        intro1: (
          <div>
            <p>
              Tropical rainforests are home to the world’s greatest biodiversity, to millions of indigenous peoples, and are essential to maintaining a stable climate. Today, our rainforests are facing greater threats than ever – and the big fund companies like Invesco that are complicit in the destruction are dragging their feet.
            </p>
            <p>
              Invesco has big investments in companies like Sysco, Tyson, Hormel and Noble Group that grow, trade or use palm oil, beef, rubber and soy in their products but have failed to eliminate deforestation from their operations. This means Invesco has a key role to play in voting for No Deforestation policies at these companies and engaging with company management to make sure these policies are implemented.
            </p>
            <p>
              In order to do that, Invesco needs to a No Deforestation Policy.
            </p>
          </div>
        ),
        intro2: (
          <div>
            <p>
              Invesco is built on a model of investment where the firm invests in virtually every public company in the world through passive funds – meaning it gives up any control over what those companies do. Despite its huge investments in both fossil fuels and the companies responsible for the global deforestation crisis, Invesco has taken no responsibility for the destruction these companies cause to our forests, our climate, and the rights of communities.
            </p>
            <p>
              Large fund companies like Invesco have the power move the entire market and play a crucial role in averting catastrophic climate outcomes, and instead finance the transition to a livable planet. But they won’t do it without pressure from us.
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Urge Invesco to adopt a No Deforestation Policy!</b>
              </ScrollLink>
            </p>
          </div>
        ),
        letter: (
          <div>
            <p>
              Dear Fund Manager,
            </p>
            <p>
              Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.
            </p>
            <p>
              Environmental and human rights impacts – and climate impacts above all – are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector – and now is the time for you to get on board.
            </p>
            <p>
              Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe Invesco needs to do the same. It is both a moral and an economic imperative. You have tremendous power – and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.
            </p>
            <p>
              Thank you.
            </p>
          </div>
        ),
      },
      jpmorgan: {
        companyshortname: 'JPMorgan',
        companyfullname: 'JPMorgan',
        title: 'JPMorgan Needs a No Deforestation Policy',
        pathname: 'JPMorgan',
        url: 'https://actionnetwork.org/petitions/jpmorgan-needs-a-no-deforestation-policy/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/jpmorgan-needs-a-no-deforestation-policy?format=js&source=widget',
        widgetid: 'can-petition-area-jpmorgan-needs-a-no-deforestation-policy',
        imgpath: 'JPMorgan',
        intro1: (
          <div>
            <p>
              Tropical rainforests are home to the world’s greatest biodiversity, to millions of indigenous peoples, and are essential to maintaining a stable climate. Today, our rainforests are facing greater threats than ever – and the big fund companies like JPMorgan that are complicit in the destruction are dragging their feet.
            </p>
            <p>
              JPMorgan has big investments in companies like Sysco, Tyson, Hormel and Noble Group that grow, trade or use palm oil, beef, rubber and soy in their products but have failed to eliminate deforestation from their operations. This means JPMorgan has a key role to play in voting for No Deforestation policies at these companies and engaging with company management to make sure these policies are implemented.
            </p>
            <p>
              In order to do that, JPMorgan needs to a No Deforestation Policy.
            </p>
          </div>
        ),
        intro2: (
          <div>
            <p>
              JPMorgan is built on a model of investment where the firm invests in virtually every public company in the world through passive funds – meaning it gives up any control over what those companies do. Despite its huge investments in both fossil fuels and the companies responsible for the global deforestation crisis, JPMorgan has taken no responsibility for the destruction these companies cause to our forests, our climate, and the rights of communities.
            </p>
            <p>
              Large fund companies like JPMorgan have the power move the entire market and play a crucial role in averting catastrophic climate outcomes, and instead finance the transition to a livable planet. But they won’t do it without pressure from us.
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Urge JPMorgan to adopt a No Deforestation Policy!</b>
              </ScrollLink>
            </p>
          </div>
        ),
        letter: (
          <div>
            <p>
              Dear Fund Manager,
            </p>
            <p>
              Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.
            </p>
            <p>
              Environmental and human rights impacts – and climate impacts above all – are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector – and now is the time for you to get on board.
            </p>
            <p>
              Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe JPMorgan needs to do the same. It is both a moral and an economic imperative. You have tremendous power – and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.
            </p>
            <p>
              Thank you.
            </p>
          </div>
        ),
      },
      mfs: {
        companyshortname: 'MFS',
        companyfullname: 'MFS',
        title: 'MFS Needs a No Deforestation Policy',
        pathname: 'MFS',
        url: 'https://actionnetwork.org/petitions/mfs-needs-a-no-deforestation-policy-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/mfs-needs-a-no-deforestation-policy-2?format=js&source=widget',
        widgetid: 'can-petition-area-mfs-needs-a-no-deforestation-policy-2',
        imgpath: 'MFS',
        intro1: (
          <div>
            <p>
              Every year, the world is losing an area of tropical rainforest the size of the United Kingdom. 
            </p>
            <p>
              Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions. Corporate control of land for industrial plantation agriculture is also a leading cause of violent land conflicts, as these activities dispossess and displace local communities.
            </p>
            <p>
              MFS has big investments in companies like Archer Daniels Midland, Pepsico and Procter & Gamble that grow, trade or use palm oil, beef, pulp and soy in their products but have failed to eliminate deforestation from their operations. This means MFS has a key role to play in voting for No Deforestation policies at these companies and engaging with company management to make sure these policies are implemented.
            </p>
            <p>
              In order to do that, MFS needs to get its own house in order. 
            </p>
          </div>
        ),
        intro2: (
          <div>
            <p>
              If they take appropriate action, large mutual fund companies have the power to move the entire market and play a crucial role in averting catastrophic climate outcomes, and instead finance the transition to a livable planet. But they won’t do it without pressure from us.
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Urge MFS to adopt a No Deforestation Policy!</b>
              </ScrollLink>
            </p>
          </div>
        ),
        letter: (
          <div>
            <p>
              Dear Fund Manager,
            </p>
            <p>
              Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.
            </p>
            <p>
              Environmental and human rights impacts – and climate impacts above all – are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector – and now is the time for you to get on board.
            </p>
            <p>
              Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe MFS needs to do the same. It is both a moral and an economic imperative. You have tremendous power – and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.
            </p>
            <p>
              Thank you.
            </p>
          </div>
        ),
      },
      statestreet: {
        companyshortname: 'State Street',
        companyfullname: 'State Street',
        title: 'State Street Needs a No Deforestation Policy',
        pathname: 'State%20Street',
        url: 'https://actionnetwork.org/petitions/state-street-needs-a-no-deforestation-policy-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/state-street-needs-a-no-deforestation-policy-2?format=js&source=widget',
        widgetid: 'can-petition-area-state-street-needs-a-no-deforestation-policy-2',
        imgpath: 'SPDR State Street Global Advisors',
        intro1: (
          <div>
            <p>
              State Street is one of the largest and most influential investment firms in the world. Unlike many large investors, State Street actually has a number of fossil free funds – which shows that State Street understands the existential threat of climate change. 
            </p>
            <p>
              Yet, even in its fossil-free funds, and across its portfolios, State Street still has huge investments in companies like JBS, Sime Darby, Posco and Mitsubishi that grow and trade palm oil, beef, and rubber, and others like Tesco and Carrefour that use these commodities in their products but have failed to eliminate deforestation from their operations. This means State Street has a key role to play in voting for No Deforestation policies at these companies and engaging with company management to make sure these policies are implemented.
            </p>
          </div>
        ),
        intro2: (
          <div>
            <p>
              If they take appropriate action, large fund companies can move the entire market and play a crucial role in averting catastrophic climate outcomes, and instead finance the transition to a livable planet. But they won’t do it without pressure from us. 
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Urge State Street to adopt a No Deforestation Policy!</b>
              </ScrollLink>
            </p>
          </div>
        ),
        letter: (
          <div>
            <p>
              Dear Fund Manager,
            </p>
            <p>
              Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.
            </p>
            <p>
              Environmental and human rights impacts – and climate impacts above all – are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector – and now is the time for you to get on board.
            </p>
            <p>
              Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe State Street needs to do the same. It is both a moral and an economic imperative. You have tremendous power – and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.
            </p>
            <p>
              Thank you.
            </p>
          </div>
        ),
      },
      troweprice: {
        companyshortname: 'T. Rowe Price',
        companyfullname: 'T. Rowe Price',
        title: 'T. Rowe Price Needs a No Deforestation Policy',
        pathname: 'T%20Rowe%20Price',
        url: 'https://actionnetwork.org/petitions/t-rowe-price-needs-a-no-deforestation-policy-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/t-rowe-price-needs-a-no-deforestation-policy-2?format=js&source=widget',
        widgetid: 'can-petition-area-t-rowe-price-needs-a-no-deforestation-policy-2',
        imgpath: 'T. Rowe Price',
        intro1: (
          <div>
            <p>
              Every year, the world loses an area of tropical rainforest the size of the United Kingdom.
            </p>
            <p>
              Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions. Corporate control of f land for industrial plantation agriculture is also a leading cause of violent land conflicts, as these activities dispossess and displace local communities.
            </p>
            <p>
              T. Rowe Price has huge investments in companies like Sysco, Tyson, Hormel and Sumitomo Rubber that grow, trade or use palm oil, beef, rubber and soy in their products but have failed to eliminate deforestation from their operations. This means T. Rowe Price has a key role to play in voting for No Deforestation policies at these companies and engaging with company management to make sure these policies are implemented.
            </p>
            <p>
              In order to do that, T. Rowe Price needs to get its own house in order.
            </p>            
          </div>
        ),
        intro2: (
          <div>
            <p>
              If they take appropriate action, large mutual fund companies can move the entire market and play a crucial role in averting catastrophic climate outcomes, and instead finance the transition to a livable planet. But they won’t do it without pressure from us.  
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Urge T. Rowe Price to adopt a No Deforestation Policy!</b>
              </ScrollLink>
            </p>
          </div>
        ),
        letter: (
          <div>
            <p>
              Dear Fund Manager,
            </p>
            <p>
              Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.
            </p>
            <p>
              Environmental and human rights impacts – and climate impacts above all – are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector – and now is the time for you to get on board.
            </p>
            <p>
              Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe T. Rowe Price needs to do the same. It is both a moral and an economic imperative. You have tremendous power – and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.
            </p>
            <p>
              Thank you.
            </p>
          </div>
        ),
      },
      tiaainvestmentsnuveen: {
        companyshortname: 'TIAA Investments Nuveen',
        companyfullname: 'TIAA Investments Nuveen',
        title: 'TIAA Investments Nuveen Needs a No Deforestation Policy',
        pathname: 'TIAA%20Investments%20Nuveen',
        url: 'https://actionnetwork.org/petitions/tiaanuveen-needs-a-no-deforestation-policy/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/tiaanuveen-needs-a-no-deforestation-policy?format=js&source=widget',
        widgetid: 'can-petition-area-tiaanuveen-needs-a-no-deforestation-policy',
        imgpath: 'TIAA Investments Nuveen',
        intro1: (
          <div>
            <p>
              Along with its subsidiary Nuveen, TIAA is one of the largest pension funds in the U.S. Despite its reputation for social responsibility, TIAA is also one of the world’s largest investors in fossil fuels and agribusiness, and the largest investor of farmland in the world, with almost 2 million acres of farmland on four continents worth as much as $10 billion. 
            </p>
            <p>
              But TIAA’s agribusiness investments and farmland deals are causing more harm than it lets on. These deals are driving land grabs, deforestation, and human rights violations, and they’re squeezing out family farmers and rural communities.
            </p>
          </div>
        ),
        intro2: (
          <div>
            <p>
              TIAA is buying farmland in countries and in regions where land grabbing and fraud are widespread. Its activities are both contributing to and benefiting from the dispossession of local communities, increasing hunger, and violence. TIAA’s farmland deals also come at a heavy ecological cost. They are destroying the environment and contaminating water sources because they promote and spread a plantation model of agriculture that relies heavily on chemical inputs.
            </p>
            <p>
              TIAA also holds millions of dollars of shares in palm oil, timber and beef producers like Tyson, Hormel, International Paper and Golden-Agri Resources, but has resisted efforts to pressure these companies to address their deforestation problem. 
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Demand that TIAA stop buying farmland and institute a No Deforestation Policy!</b>
              </ScrollLink>
            </p>
            <p>
              As a firm that manages funds for academics and non-profits, TIAA should be especially rigorous in its environmental and social standards. Together we can pressure it to change course.
            </p>
            <p styleName='scroll-link'>
              <ScrollLink
                activeClass='active-scroll-link'
                to='section1'
                spy
                smooth
                offset={-70}
                duration={500}
              >
                <b>Tell TIAA to adopt a No Deforestation Policy and get out of farmland altogether!</b>
              </ScrollLink>
            </p>
          </div>
        ),
        letter: (
          <div>
            <p>
              Dear Members of TIAA’s Corporate Governance and Social Responsibility Committee:
            </p>
            <p>
              I have serious concerns about TIAA’s involvement in land grabbing, deforestation, and human rights violations through its holdings in deforestation-risk commodities and its direct acquisitions of farmland.
            </p>
            <p>
              Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.
            </p>
            <p>
              Environmental and human rights impacts – and climate impacts above all – are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector – and now is the time for you to get on board.
            </p>
            <p>
              Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe TIAA needs to do the same. It is both a moral and an economic imperative. You have tremendous power – and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.
            </p>
            <p>
              In addition, given TIAA/Nuveen’s approach to farmland investment, I ask you to halt your acquisitions of farmland, especially in fragile ecosystems and areas where land title is strongly contested and to engage in an effort to return lands in the Brazilian Cerrado to local community management.
            </p>
            <p>
              Thank you.
            </p>
          </div>
        ),
      }
    }
    let petitionConfig = null
    if (
      props.manager &&
      petitionConfigs[props.manager]
    ) {
      petitionConfig = petitionConfigs[props.manager]
    }
    this.state = {
      petitionConfig: petitionConfig,
      showFullPetition: false
    }
  }

  renderLogo = (title) => {
    const fileName = format.imgPath(title)
    let hasLogo = false
    let companyLogo = null
    try {
      companyLogo = require('../../../static/images/fam/'+fileName+'.png')
      hasLogo = true
    }
    catch (e) {
      console.log('')
    }
    if (hasLogo) {
      return (
        <img
          styleName='sidebar-logo'
          src={companyLogo}
          alt={title}
        />
      )
    } else {
      console.log(fileName)
      return (
        <span>{title}</span>
      )
    }
  }

  render() {
    if (!this.state.petitionConfig) {
      return null
    }
    const manager = this.state.petitionConfig
    const headlineImg = require('../../../static/images/monkeys-circle.png')
    return (
      <div>
        {
          container.helmet(
            `Tell ${manager.companyshortname} to adopt a No Deforestation policy`,
            `Mutual fund managers are among the world’s top investors in the agribusiness companies responsible for destroying our tropical rainforests.`,
            config.domain + config.routes.petitions + '/' + manager.companyshortname
          )
        }
        <div styleName='hl-wrap'>
          { /* LEFT COLUMN */ }
          <div>
            <img
              src={headlineImg}
              alt='Save for your future without ruining theirs'
              styleName='hl-img-sm visible-xs'
            />
            <div styleName='hl'>
              Save for your future without ruining theirs
            </div>
            <div styleName='copy'>
              { manager.intro1 }
              <p styleName='scroll-link'>
                <ScrollLink
                  activeClass='active-scroll-link'
                  to='section1'
                  spy
                  smooth
                  offset={-70}
                  duration={500}
                >
                  <b>Tell { manager.companyshortname } to adopt a No Deforestation Policy!</b>
                </ScrollLink>
              </p>

              <div styleName='hidden-xs'>
                { manager.intro2 }
                { /* PETITION LETTER */ }
                <div styleName='petition-letter'>
                  <blockquote>
                    <p>
                      <b>To: { manager.companyshortname }<br/>From: As You Sow & Friends of the Earth U.S.</b>
                    </p>
                    { manager.letter }
                  </blockquote>
                </div>
              </div>

              { /* AFTER PETITION LINKS */ }
              <div styleName='after-petition-links hidden-xs'>
                <div styleName='after-petition-links-lbl'>
                  More
                </div>
                <div styleName='after-petition-links-div'>
                  <Link
                    to={config.routes.families + '?q=' + manager.pathname}
                    title={manager.companyfullname}
                    xstrong
                  >
                    See fund scores for {manager.companyfullname}<LinkIcon/>
                  </Link>
                </div>
                <div styleName='after-petition-links-div'>
                  <Link
                    to={config.routes.clean}
                    title='Search funds'
                    xstrong
                  >
                    Search all funds<LinkIcon/>
                  </Link>
                </div>
                <div styleName='after-petition-links-div'>
                  <Link
                    to={config.routes.toolkit}
                    title='#DefundDeforestation Action Toolkit'
                    xstrong
                  >
                    Action toolkit<LinkIcon/>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          { /* RIGHT COLUMN */ }
          <div styleName='hl-img-wrap'>
            <img
              src={headlineImg}
              alt='Save for your future without ruining theirs'
              styleName='hl-img hidden-xs'
            />

            { /* <div styleName='sidebar-logo-wrap'>
              <div>
              </div>
            </div> */ }

            <div styleName='petition-widget-wrap'>
              {this.renderLogo(manager.imgpath)}
              <div styleName='sticky-widget'>
                <div id='section1'/>
                <link href='https://actionnetwork.org/css/style-embed-v3.css' rel='stylesheet' type='text/css' />
                <script src={manager.widgeturl}/>
                <div id={manager.widgetid} style={{width:'100%'}}/>
                <div styleName='petition-widget-404-link'>
                  If you opt in to email updates, you may receive emails from Friends of the Earth U.S. as well.
                  <br/>
                  Something went wrong loading the petition? <Link to={manager.url} title={`${manager.companyshortname} Needs a No Deforestation Policy`} xstrong>Try signing here<LinkIcon/></Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div styleName='visible-xs'>
          <div
            styleName='show-more-button'
            title='Show the full petition'
            onClick={
              (e)=>{
                this.setState({showFullPetition: !this.state.showFullPetition})
              }
            }
          >
            Show the full petition<LinkIcon faclass={
              this.state.showFullPetition ?
                'fa-angle-double-up' :
                'fa-angle-double-down'
            }/>
          </div>
          <SlideDown>
            {
              this.state.showFullPetition ?
                (
                  <div styleName='copy'>
                    { manager.intro2 }
                    { /* PETITION LETTER */ }
                    <div styleName='petition-letter'>
                      <blockquote>
                        <p>
                          <b>To: { manager.companyshortname }<br/>From: As You Sow & Friends of the Earth U.S.</b>
                        </p>
                        { manager.letter }
                      </blockquote>
                    </div>                      </div>
                ) :
                null
            }
          </SlideDown>
        </div>

        { /* AFTER PETITION LINKS */ }
        <div styleName='after-petition-links visible-xs'>
          <div styleName='after-petition-links-lbl'>
            More
          </div>
          <div styleName='after-petition-links-div'>
            <Link
              to={config.routes.families + '?q=' + manager.pathname}
              title={manager.companyfullname}
              xstrong
            >
              See fund scores for {manager.companyfullname}<LinkIcon/>
            </Link>
          </div>
          <div styleName='after-petition-links-div'>
            <Link
              to={config.routes.clean}
              title='Search funds'
              xstrong
            >
              Search all funds<LinkIcon/>
            </Link>
          </div>
          <div styleName='after-petition-links-div'>
            <Link
              to={config.routes.toolkit}
              title='#DefundDeforestation Action Toolkit'
              xstrong
            >
              Action toolkit<LinkIcon/>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}


@CSSModules(Styles, {allowMultiple: true})
export default class Petitions extends Component {
  constructor(props) {
    super(props)

    const allowedAssetManagers = {
      vanguard: 'Vanguard',
      blackrock: 'BlackRock',
      fidelity: 'Fidelity',
      capitalgroup: 'Capital Group',
      dimensionalfundadvisors : 'Dimensional Fund Advisors',
      invesco : 'Invesco',
      jpmorgan : 'JPMorgan',
      mfs : 'MFS',
      statestreet : 'State Street',
      troweprice : 'T Rowe Price',
      tiaainvestmentsnuveen : 'TIAA Investments Nuveen',
    }

    this.state = {
      allowedAssetManagerParams: Object.keys(allowedAssetManagers),
      allowedAssetManagers: allowedAssetManagers,
      familiesWithPetitions: Object.keys(config.fundFamilyPetitions.data)
    }
  }

  renderLogo = (title) => {
    const fileName = format.imgPath(title)
    let hasLogo = false
    let companyLogo = null
    try {
      companyLogo = require('../../../static/images/fam/'+fileName+'.png')
      hasLogo = true
    }
    catch (e) {
      console.log('')
    }
    if (hasLogo) {
      return (
        <img
          styleName='logo'
          src={companyLogo}
          alt={title}
        />
      )
    } else {
      console.log(fileName)
      return (
        <span>{title}</span>
      )
    }
  }

  render() {
    const title = 'Petitions'
    const headlineImg = require('../../../static/images/monkeys-circle.png')
    const foeImg = require('../../../static/images/FOE_logo.png')

    let name = null

    // do we have a valid asset manager in params
    if (
      this.props.params &&
      this.props.params.assetManager &&
      this.state.allowedAssetManagerParams.includes(
        this.props.params.assetManager.toLowerCase().split(' ').join('')
      )
    ) {
      name = this.state.allowedAssetManagers[
        this.props.params.assetManager.toLowerCase().split(' ').join('')
      ]
    }

    //
    return (
      <div styleName='main'>

        <ContainerDivs>
          {
            name ?
              null :
              (
                <div styleName='hl-wrap'>
                  {
                    container.helmet(
                      'Petitions',
                      'Ask major asset managers to adopt a No Deforestation policy.',
                      config.domain + config.routes.petitions
                    )
                  }
                  <div>
                    <img
                      src={headlineImg}
                      alt='Save for your future without ruining theirs'
                      styleName='hl-img-sm visible-xs visible-sm'
                    />
                    <div styleName='hl'>
                      Save for your future without ruining theirs
                    </div>
                    <div styleName='copy'>
                      Are you invested with one of the asset managers below? These mutual fund managers are among the world’s top investors in the agribusiness companies responsible for destroying our tropical rainforests. Their continued financing of the world’s worst deforesters exposes them and their clients to reputational and financial risk – and they have no policies in place to stop the destruction.
                    </div>
                    <div styleName='hl-2'>
                      Choose an asset manager below to sign a petition asking them to adopt a No Deforestation policy.
                    </div>
                  </div>
                  <img
                    src={headlineImg}
                    alt='You can save for your future without ruining theirs'
                    styleName='hl-img hidden-xs hidden-sm'
                  />
                </div>
              )
          }
          {
            name ?
              (
                <ManagerPetition manager={name.toLowerCase().split(' ').join('')} />
              ) :
              (
                <div styleName='logo-grid-wrap'>
                  <Row styleName='logo-grid'>
                    {
                      [
                        {
                          fund_family: 'Vanguard',
                          imgpath: 'Vanguard',
                        },
                        {
                          fund_family: 'BlackRock',
                          imgpath: 'BlackRock/iShares',
                        },
                        {
                          fund_family: 'Fidelity',
                          imgpath: 'Fidelity Investments',
                        },
                        {
                          fund_family: 'Capital Group',
                          imgpath: 'American Funds',
                        },
                        {
                          fund_family: 'Dimensional Fund Advisors',
                          imgpath: 'Dimensional Fund Advisors',
                        },
                        {
                          fund_family: 'Invesco',
                          imgpath: 'Invesco',
                        },
                        {
                          fund_family: 'JPMorgan',
                          imgpath: 'JPMorgan',
                        },
                        {
                          fund_family: 'MFS',
                          imgpath: 'MFS',
                        },
                        {
                          fund_family: 'State Street',
                          imgpath: 'SPDR State Street Global Advisors',
                        },
                        {
                          fund_family: 'T Rowe Price',
                          imgpath: 'T. Rowe Price',
                        },
                        {
                          fund_family: 'TIAA Investments Nuveen',
                          imgpath: 'TIAA Investments/Nuveen',
                        }
                      ].map((e, i) => {
                        return (
                          <Col
                            styleName='logo-cell'
                            md={3}
                            sm={6}
                            xs={12}
                            key={'logo-cell-'+i}
                          >
                            <div styleName='logo-cell-inner'>
                              <Link
                                to={config.routes.petitions + '/' + e.fund_family}
                                title={
                                  'Sign the petition to ask ' +
                                  e.fund_family +
                                  ' for a No Deforestation Policy'
                                }
                                log={
                                  analytics.eventToFamilyTakeAction(
                                    e.fund_family
                                  )
                                }
                                targetBlank
                              >
                                {this.renderLogo(e.imgpath)}
                              </Link>
                            </div>
                          </Col>
                        )
                      })
                    }
                  </Row>
                </div>
              )
          }

          { /* <div styleName='disclaim'>
            Petitions are hosted by Friends of the Earth U.S.
          </div>
          <img
            styleName='foe-logo'
            src={foeImg}
            alt='Petitions are hosted by Friends of the Earth U.S.'
          /> */ }

        </ContainerDivs>
      </div>
    )
  }
}